import React from 'react';
import { Flex, Text, HStack, Icon, VStack, useColorModeValue, Switch, IconButton } from '@chakra-ui/react';
import { InfoOutlineIcon, EditIcon, DeleteIcon } from '@chakra-ui/icons';

const MobileDataTable = ({
   data = [],
   customerRight = false,
   handleViewSingleData,
   handleStatusUpdate,
   onEditClick,
   onDeleteClick,
   emptyMessage = 'No data found',
}) => {
   const textColor = useColorModeValue('gray.700', 'gray.100');
   const amountColor = useColorModeValue('green.600', 'green.300');
   const borderColor = useColorModeValue('gray.200', 'gray.600');

   return (
      <VStack spacing={2} w="full" p={0}>
         {Array.isArray(data) && data.length > 0 ? (
            data.map((item, index) => (
               <Flex
                  key={item.id || index}
                  align="center"
                  justify="space-between"
                  px={2}
                  py={2}
                  w="full"
                  borderTop="1px solid"
                  borderColor={borderColor}
                  cursor={handleViewSingleData ? 'pointer' : 'default'}
                  onClick={(e) => {
                     const isSwitch = e.target?.closest('.status-switch');
                     const isButton = e.target?.closest('.action-btn');
                     if (!isSwitch && !isButton && handleViewSingleData) {
                        handleViewSingleData(item.id);
                     }
                  }}>
                  {/* Name and Info Icon */}
                  <HStack spacing={2} minW="35%">
                     <Text fontWeight="normal" fontSize="14px" color={textColor}>
                        {item.name || item.companyName || 'N/A'}
                     </Text>
                     {item.hasInfoIcon && <Icon as={InfoOutlineIcon} color="orange.400" boxSize={4} />}
                  </HStack>

                  {/* Status Switch */}
                  {handleStatusUpdate !== undefined && (
                     <Switch
                        className="status-switch"
                        isChecked={item.status === 1 || item.status === true}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => handleStatusUpdate(item.id, e.target.checked)}
                        size="sm"
                        colorScheme="teal"
                     />
                  )}

                  {/* Amount */}
                  {customerRight && (
                     <Text
                        fontWeight="bold"
                        fontSize="sm"
                        color={item.amount > 0 ? amountColor : textColor}
                        minW="80px"
                        textAlign="right">
                        ₹ {Number(item.amount || 0).toFixed(2)}
                     </Text>
                  )}

                  {/* Optional Edit/Delete Buttons */}
                  {(onEditClick || onDeleteClick) && (
                     <HStack spacing={1}>
                        {onEditClick && (
                           <IconButton
                              className="action-btn"
                              aria-label="Edit"
                              icon={<EditIcon />}
                              size="sm"
                              variant="ghost"
                              colorScheme="blue"
                              onClick={(e) => {
                                 e.stopPropagation();
                                 onEditClick(item);
                              }}
                           />
                        )}
                        {onDeleteClick && (
                           <IconButton
                              className="action-btn"
                              aria-label="Delete"
                              icon={<DeleteIcon />}
                              size="sm"
                              variant="ghost"
                              colorScheme="red"
                              onClick={(e) => {
                                 e.stopPropagation();
                                 onDeleteClick(item.id);
                              }}
                           />
                        )}
                     </HStack>
                  )}
               </Flex>
            ))
         ) : (
            <Text color="gray.500" fontSize="md">
               {emptyMessage}
            </Text>
         )}
      </VStack>
   );
};

export default MobileDataTable;
